import styled from 'styled-components'

const AButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
`

export default AButtonGroup
